/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

const CustomPriceComponent = React.memo((props) => {
  const { value, data } = props;
  const RedColor = '#a81f00';

  if (data?.isBottomRow) {
    return (
      <span
        className={data?.isBottomRow ? 'semiBoldText' : ''}
        style={{
          color:
            value !== null && parseFloat(value) < 0 && data?.isBottomRow
              ? RedColor
              : '#000',
          fontWeight:
            value !== null && parseFloat(value) < 0 && data?.isBottomRow
              ? RedColor
              : 400,
        }}
      >
        {value
          ? parseFloat(value) < 0 && data?.isBottomRow
            ? `($ ${(parseFloat(value) * -1)?.toFixed(2)})`
            : `$ ${parseFloat(value)?.toFixed(2)}`
          : '$ 0.00'}
      </span>
    );
  } else {
    return (
      <span
        className={data?.isBottomRow ? 'semiBoldText' : ''}
        style={{
          color:
            value !== null && parseFloat(value) < 0 && data?.claimIdVO
              ? RedColor
              : '#000',
          fontWeight:
            value !== null && parseFloat(value) < 0 && data?.claimIdVO
              ? 600
              : 400,
        }}
      >
        {value
          ? parseFloat(value) < 0 && data?.claimIdVO
            ? `($ ${(parseFloat(value) * -1)?.toFixed(2)})`
            : `$ ${parseFloat(value)?.toFixed(2)}`
          : '$ 0.00'}
      </span>
    );
  }
});

export default CustomPriceComponent;
